module.exports = __webpack_public_path__ + "static/media/rolletPhoto.9a9bd50f.jpg";